export default __webpack_public_path__ + "static/media/logo_png.774cd405.png";